module.exports = __webpack_public_path__ + "static/media/youtube.17dd6aca.svg";